module.exports = __webpack_public_path__ + "static/media/list-to-map.5a673364.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/yelp/src/list-to-map.mov
// module id = 224
// module chunks = 0